import React, { useContext } from "react";
import { LoadingDots, PageShell, QueryResult } from "@sscs/ui";
import { Outlet } from "react-router";
import { ReportContext } from "./context";
import { useResetFileBrowserSlices } from "./hooks";
import Navigation from "./navigation/Navigation";
import styles from "./sdlcReport.module.scss";
import { useGetReportSummaryQuery } from "./services/shared.api";
const SDLCReport = () => {
    const { reportId, diffId } = useContext(ReportContext);
    const { data: reportSummaryData, isLoading, isError, error, } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    useResetFileBrowserSlices();
    const paneContent = () => {
        if (isLoading)
            return (React.createElement("div", { className: styles.loading },
                React.createElement(LoadingDots, null)));
        if (isError || !reportSummaryData)
            return React.createElement(QueryResult, { status: { status: "ERROR", error } });
        return React.createElement(Outlet, null);
    };
    return (React.createElement(PageShell, { sidebar: reportSummaryData ? (React.createElement(Navigation, { summary: reportSummaryData })) : undefined, contentClassName: styles.report }, paneContent()));
};
export default SDLCReport;
//# sourceMappingURL=SDLCReport.js.map